import { render } from "./Gorevlerim.vue?vue&type=template&id=e9a6348a&scoped=true"
import script from "./Gorevlerim.vue?vue&type=script&lang=js"
export * from "./Gorevlerim.vue?vue&type=script&lang=js"

import "./Gorevlerim.vue?vue&type=style&index=0&id=e9a6348a&scoped=true&lang=css"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9a6348a"]])

export default __exports__